exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cameraPicture[data-v-13fd97c2]{left:520px;top:200px}.text-white-60[data-v-13fd97c2]{color:#fff;opacity:.6}", ""]);

// exports
